// src/utils/supportEmailAPI.js
export const sendSupportEmailAPI = async (supportData) => {
  console.log('📧 [supportEmailAPI.js] Starting sendSupportEmailAPI function');
  console.log('📧 [supportEmailAPI.js] Support data:', supportData);
  
  try {
    console.log('📧 [supportEmailAPI.js] Sending POST request to /api/support');
    
    const API_URL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${API_URL}/api/support`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(supportData),
    });

    console.log('📧 [supportEmailAPI.js] Response status:', response.status);
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ [supportEmailAPI.js] API error response:', errorData);
      throw new Error(errorData.error || 'Failed to send support request');
    }

    const result = await response.json();
    console.log('✅ [supportEmailAPI.js] Support request sent successfully:', result);
    return result;
    
  } catch (error) {
    console.error('❌ [supportEmailAPI.js] Error sending support request:', error);
    console.error('❌ [supportEmailAPI.js] Error details:', error.message);
    throw error;
  }
};